import React from 'react';
import { hot } from 'react-hot-loader';
import { translate } from '../../utils/locale';
import { formatPriceByExample, urlify } from '../../utils/string';
import s from './Totals.scss';

const Totals = ({ setup, selection, cart = false }) => {
	const { totals, discounts } = selection;
	const checkoutShippingText = selection.shippingMethod ? `checkoutShipping${selection.shippingMethod.toUpperCase()}` : 'checkoutShipping';
	const removeAddDiscounts = Math.round(discounts.automaticDiscounts.reduce((acc, d) => (urlify(d.name).indexOf('add-on') !== -1 ? acc - d.priceOffAsNumber : acc), 0));

	return (
		<div className={[s.totals, cart ? s.totals__cart : null].join(' ')}>
			<div className={s.totals_row}>
				<span>{ translate(setup, 'checkoutProductTotal') }</span>
				<span>{ removeAddDiscounts === 0 ? totals.itemsTotalPrice : formatPriceByExample(totals.itemsTotalPrice, Math.round(totals.itemsTotalPriceAsNumber - removeAddDiscounts)) }</span>
			</div>
			{
				totals.taxDeducted && (
					<div className={s.totals_row}>
						<span>{ translate(setup, 'checkoutTaxReduction') }</span>
						<span>{ totals.taxDeducted }</span>
					</div>
				)
			}
			<div className={s.totals_row}>
				<span>
					{ (setup.statics[checkoutShippingText] ? translate(setup, checkoutShippingText) : translate(setup, 'checkoutShipping')).replace('%country%', setup.countries[setup.country].name) }
				</span>
				{ totals.shippingPriceAsNumber === 0 && <span>{ translate(setup, 'checkoutFreeShipping') }</span> }
				<span>{ totals.shippingPrice }</span>
			</div>
			{
				discounts.anyDiscount && Math.round(removeAddDiscounts + totals.totalDiscountPriceAsNumber) < 0 && (
					<div className={[s.totals_row, s.totals_row__discount].join(' ')}>
						<span>{ translate(setup, 'checkoutDiscount') }</span>
						<span>{ formatPriceByExample(totals.itemsTotalPrice, Math.round(removeAddDiscounts + totals.totalDiscountPriceAsNumber)) }</span>
					</div>
				)
			}
			{
				totals.taxAdded && (
					<div className={s.totals_row}>
						<span>{ setup.country === 'CA' ? translate(setup, 'taxAddedImportDuty') : translate(setup, 'checkoutTaxAdded') }</span>
						<span>{ totals.taxAdded }</span>
					</div>
				)
			}
			<div className={[s.totals_row, s.totals_row__grandTotal].join(' ')}>
				<span><strong>{translate(setup, 'checkoutGrandTotal')}</strong>{ totals.taxAdded ? ` (${translate(setup, 'taxAddedCheckoutTotal')})` : '' }</span>
				<span><strong>{ totals.grandTotalPrice }</strong></span>
			</div>
			{
				totals.grandTotalPriceTaxAsNumber > 0 && !totals.taxAdded && !cart && (
					<div className={[s.totals_row, s.totals_row__includingTax].join(' ')}>
						<span>{ translate(setup, 'checkoutIncludingTax') }</span>
						<span>({totals.grandTotalPriceTax})</span>
					</div>
				)
			}
		</div>
	);
};

export default hot(module)(Totals);
